/**
 * PreloadScene - boot-time asset loader.
 *
 * Runs first, before the Menu. Tries to load every sprite + sound declared
 * in their respective registries. Shows a minimal progress bar while loading
 * (loads are usually instant on localhost, but the bar exists so a slow CDN
 * doesn't leave the user staring at a black screen).
 *
 * Critically: loader errors are NOT fatal. If a file 404s, AssetManager /
 * SoundManager records it as unavailable and the rest of the game uses
 * placeholders / silence. This lets the asset pipeline absorb partial drops
 * during development without breaking the game.
 */

import Phaser from 'phaser';
import { VIEWPORT_PX_W, VIEWPORT_PX_H } from '../config';
import { AssetManager } from '../assets/AssetManager';
import { SoundManager } from '../sound/SoundManager';

export class PreloadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'Preload' });
  }

  preload(): void {
    AssetManager.preloadInto(this);
    SoundManager.preloadInto(this);

    // Progress bar
    const w = VIEWPORT_PX_W;
    const h = VIEWPORT_PX_H;
    const barW = w * 0.6;
    const barH = 6;
    const barX = (w - barW) / 2;
    const barY = h / 2 + 30;

    this.add
      .text(w / 2, h / 2 - 20, 'SPLAT CHIMP', {
        fontFamily: 'monospace',
        fontSize: '32px',
        fontStyle: 'bold',
        color: '#e8c87a',
      })
      .setOrigin(0.5);

    const bg = this.add.rectangle(w / 2, barY, barW, barH, 0x222222);
    bg.setStrokeStyle(1, 0x555555);
    const fill = this.add.rectangle(barX, barY, 0, barH, 0x7adb6b).setOrigin(0, 0.5);

    this.load.on(Phaser.Loader.Events.PROGRESS, (p: number) => {
      fill.width = barW * p;
    });
  }

  create(): void {
    AssetManager.finalize(this);
    AssetManager.reportOnce();
    SoundManager.reportOnce();
    this.scene.start('Menu');
  }
}
